import { useEffect } from 'react'

export const useCatPrivacyNotice = (active: boolean) => {
  useEffect(() => {
    if (!active) return

    const existing = document.getElementById('otprivacy-notice-script')
    if (existing) return

    const notice =
      'https://privacyportal-cdn.onetrust.com/storage-container/dacb864b-cd78-48d1-a68b-5f1d05fe1473/privacy-notices/7f61a611-db7f-40a6-877f-fa0ae844b1bf/published/privacynotice.json'

    const script = document.createElement('script')
    script.src =
      'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js'
    script.type = 'text/javascript'
    script.id = 'otprivacy-notice-script'
    script.setAttribute(
      'settings',
      'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyIsImNvbnRlbnRBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L2NvbnRlbnQiLCJtZXRhZGF0YUFwaVVybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0=',
    )
    script.async = true

    const loadNotices = () => {
      const oneTrustApi = (window as any).OneTrust?.NoticeApi
      if (!oneTrustApi) return
      const init = oneTrustApi.Initialized
      if (init && typeof init.then === 'function') {
        init.then(() => {
          oneTrustApi.LoadNotices([notice])
        })
      } else {
        oneTrustApi.LoadNotices([notice])
      }
    }

    script.onload = loadNotices
    document.body.appendChild(script)

    return () => {
      const el = document.getElementById('otprivacy-notice-script')
      if (el) el.remove()
    }
  }, [active])
}
